import * as React from "react";

const SvgComponent = ({ color = "#636F7C", width = "16px", height ="16px",...props}) => (
  <svg
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 16 16"
    className="signal-icon"
    {...props}
  >
    <path
      d="M15.646 4.834A10.738 10.738 0 0 0 8 1.667 10.738 10.738 0 0 0 .354 4.834a1.18 1.18 0 0 0 0 1.684c.235.236.539.354.842.354.303 0 .606-.118.842-.354A8.327 8.327 0 0 1 8 4.042c2.257 0 4.379.876 5.962 2.476a1.18 1.18 0 0 0 1.684 0 1.18 1.18 0 0 0 0-1.684Z"
      fill={color}
    />
    <path
      d="M3.52 8.017a1.18 1.18 0 0 0 0 1.684c.235.236.539.354.842.354.303 0 .606-.118.842-.354 1.55-1.55 4.059-1.55 5.591-.017a1.18 1.18 0 0 0 1.685 0 1.18 1.18 0 0 0 0-1.684 6.348 6.348 0 0 0-8.96.017ZM9.87 12.48a1.853 1.853 0 1 1-3.706 0 1.853 1.853 0 0 1 3.705 0Z"
      fill={color}
    />
  </svg>
);

export default SvgComponent;
